// extracted by mini-css-extract-plugin
export default {"navBar":"NavBar_navBar__iPaMU","title":"NavBar_title__dUFGe"};